import { CreateRestrictionRequestDto } from '@/services/dto/restrictions/create-restriction-input.dto';
import { UpdateRestrictionRequestDto } from '@/services/dto/restrictions/update-restriction-input.dto';
import { useRestrictionsForm } from '@/hooks/restrictions/useRestrictionsForm';
import { Coin } from '@/models/coin';
import { useFormContext } from 'react-hook-form';
import {
  AutocompleteMenuSelector,
  AutocompleteSelectorOptionCoinWithImage,
  ErrorChip,
  FormGroup,
  SelectInputWithImage,
} from '@starsoft/common/components';
import AutocompleteSelectorOptionWithImageSkeleton from '@starsoft/common/components/AutocompleteMenuSelector/CustomOptions/AutocompleteSelectorAccount/Skeleton';
import SelectInputWithImageSkeleton from '@starsoft/common/components/SelectInput/SelectWithImage/SelectInputWithImage/Skeleton';
import { SettingsService } from '@starsoft/common/services';
import useTranslation from 'next-translate/useTranslation';
import { useCoins } from '@starsoft/common/api';

export default function RestricitonsModalContentCoinSelector() {
  const { t } = useTranslation('account');
  const { setValue, watch } = useFormContext<
    CreateRestrictionRequestDto & UpdateRestrictionRequestDto
  >();
  const {
    useRestrictionByIdQuery: { isLoadingRestriction },
  } = useRestrictionsForm();
  const {
    coins,
    isPending,
    error,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useCoins();

  const coin = watch('coinId');

  function handleSelect(option: Coin) {
    setValue('coinId', option.id, {
      shouldDirty: true,
    });
    setValue('coin', option);
  }

  if (error) {
    return <ErrorChip action={refetch} />;
  }

  return (
    <FormGroup
      label={t('restriction_coin_label') as string}
      isLoading={isLoadingRestriction || isPending}
      loading={{ label: true, secondary: true }}
    >
      <AutocompleteMenuSelector
        options={coins ?? []}
        filterBy={['name']}
        setValue={handleSelect}
        value={coin}
        getOptionLabel={e => e.name}
        getOptionValue={e => e?.id}
        loading={isPending || isLoadingRestriction}
        loadMore={fetchNextPage}
        hasNextPage={hasNextPage}
        hideSearch
        loadingMore={isFetchingNextPage}
        title={t('restriction_coin_label') as string}
        customComponents={{
          customOption: ({ handleSelect, option, selected }) => (
            <AutocompleteSelectorOptionCoinWithImage
              handleSelect={handleSelect}
              option={option}
              selected={selected}
            />
          ),
          customInput: ({ handleOpen, open, option }) => (
            <SelectInputWithImage
              handleOpen={handleOpen}
              open={open}
              image={`${SettingsService.env.S3_BUCKET_BASE_URL}/coins/rounded/${option?.image}`}
              label={option?.code ?? ''}
            />
          ),
          customSkeletonOption: () => (
            <AutocompleteSelectorOptionWithImageSkeleton />
          ),

          customSkeletonInput: () => <SelectInputWithImageSkeleton />,
        }}
      />
    </FormGroup>
  );
}
